import { postBiz, json } from '../core/coreapi';

export const fetchCaWorkbench = (planningcycleid:number) =>
  json(postBiz({s:'governance', a:'workbench', pci:planningcycleid}));

export const createCaPackage = (planningcycleid:number, payload:any) =>
  json(postBiz({s:'careviewpackage', a:'create', pci:planningcycleid, ...payload}));

export const submitCaPackage = (packageid:number, notes:string='') =>
  json(postBiz({s:'careviewpackage', a:'submit', rid:packageid, nts:notes}));

export const recordCaDecision = (payload:any) =>
  json(postBiz({s:'cadecision', a:'record', ...payload}));
